module.exports = __webpack_public_path__ + "static/media/residential-high-rise.1a8e19c2.svg";